// -*- Mode: rjsx -*-
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import ReplayIcon from '@mui/icons-material/Replay';

import { doRecall } from '..';
import { updateRequest } from '../../request';

function Recall(props) {
    const dispatch = useDispatch();
    const request = props.request;
    function click(e) {
        dispatch(doRecall({ requestKey: request.key }) )
            .then((data) => {
                let req = data.payload.request;
                console.log("req: %o", req);
                dispatch(updateRequest(req));
            });
    }
    
    return (
        <Card>
          <CardHeader title="Awaiting Mentor Approval">
            Recall
          </CardHeader>
          <CardContent>
            <p>This response is awaiting mentor approval.</p>
            <Button
              variant="contained"
              color="primary"
              startIcon={<ReplayIcon />}
              onClick={click}>Edit this response</Button>
          </CardContent>
        </Card>
    );
}

export default Recall;
